import { Box, Stack, Typography } from '@mui/material';
import { HomeIconLabel } from './HomeIconLabel';
import { ArticleListPreview } from '@xolv-mybrightlink/articles';
import { EventListPreview } from '@xolv-mybrightlink/events';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import {
  Routes,
  useAnalytics,
  METRICS_ARTICLES_ACTIVITY_ACCESS,
  METRICS_ARTICLES_PROPERTY_SOURCE,
  METRICS_ARTICLES_PROPERTY_SOURCE_HOME_PAGE,
  METRICS_EVENTS_ACTIVITY_ACCESS,
  METRICS_EVENTS_PROPERTY_SOURCE,
  METRICS_EVENTS_PROPERTY_SOURCE_HOME_PAGE,
} from '@xolv-mybrightlink/common';
import { SurveyLoader, Survey } from '@xolv-mybrightlink/mybrightlink';
import { WelcomeBack } from './WelcomeBack';
import { SurveySection } from './SurveySection';

export const Home = () => {
  const navigate = useNavigate();
  const analytics = useAnalytics();
  return (
    <Box sx={{ height: '100%', overflow: 'auto' }} className='hide-scrollbar'>
      <Box sx={{ display: 'flex' }}>
        <Box
          sx={{
            overflow: 'auto',
            flex: 1,
          }}
          className='hide-scrollbar'
        >
          <Box
            sx={{
              background:
                'linear-gradient(180deg, rgba(236,244,255,1) 0%, rgba(202,223,251,1) 100%)',
              px: 10,
              pt: 10,
              pb: 7,
            }}
          >
            <WelcomeBack />
            <SurveyLoader>
              {(surveys: Survey[]) => <SurveySection surveys={surveys} />}
            </SurveyLoader>
          </Box>
          <Box
            sx={{
              px: 10,
              py: 10,
            }}
          >
            {/*
          hide CareSection for Web 1.0
          <CareSection />
          */}
            <Box sx={{ mt: 10, mr: 5, mb: 5 }}>
              <Stack
                direction='row'
                justifyContent='space-between'
                alignItems='center'
              >
                <HomeIconLabel
                  labelKey='home.label.articles'
                  src='/public/assets/icons/ic_articles_header.svg'
                />
                <Typography
                  onClick={() => {
                    analytics.trackAction(METRICS_ARTICLES_ACTIVITY_ACCESS, {
                      [METRICS_ARTICLES_PROPERTY_SOURCE]:
                        METRICS_ARTICLES_PROPERTY_SOURCE_HOME_PAGE,
                    });
                    navigate(Routes.resources.articles.index);
                  }}
                  sx={{
                    color: '#307fe2',
                    fontSize: 16,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                >
                  <FormattedMessage id='home.action.view-all' />
                </Typography>
              </Stack>
            </Box>
            <ArticleListPreview />
            <Box sx={{ mt: 10, mr: 5, mb: 5 }}>
              <Stack
                direction='row'
                justifyContent='space-between'
                alignItems='center'
              >
                <HomeIconLabel
                  labelKey='home.label.events'
                  src='/public/assets/icons/ic_events_header.svg'
                />
                <Typography
                  onClick={() => {
                    analytics.trackAction(METRICS_EVENTS_ACTIVITY_ACCESS, {
                      [METRICS_EVENTS_PROPERTY_SOURCE]:
                        METRICS_EVENTS_PROPERTY_SOURCE_HOME_PAGE,
                    });
                    navigate(Routes.resources.events.index);
                  }}
                  sx={{
                    color: '#307fe2',
                    fontSize: 16,
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                >
                  <FormattedMessage id='home.action.view-all' />
                </Typography>
              </Stack>
            </Box>
            <EventListPreview />
          </Box>
        </Box>
        <Box
          sx={{ height: '100%', '&:has(*)': { width: 0.25, marginLeft: 4 } }}
        >
          {/*action area: CSAT, schedules, to-do*/}
        </Box>
      </Box>
    </Box>
  );
};
